import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject, finalize, of } from 'rxjs';
import {
    distinctUntilChanged,
    switchMap,
    catchError,
    tap,
    map,
    takeUntil,
    debounceTime,
} from 'rxjs/operators';
import { helper } from 'src/environments/helper';
import { NotificationService } from '../../../services/notification.service';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { DestinatieTableDataRow, DocumentData, FileUpload, GeneralData } from '../document.interface';
import { formatDate } from '@angular/common';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-document-intern',
    templateUrl: './document-intern.component.html',
    styleUrls: ['./document-intern.component.scss'],
})
export class DocumentInternComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;
    uploading = false;

    showRegistreFields = true;
    showProceduraField = true;
    showFormFiles = false;
    showFormDestinatie = false;

    registruOficialGeneralValue: number | null = null;

    docData: DocumentData | null = null;

    tableData: DestinatieTableDataRow[] = [];

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    newNumberOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Emitere cu număr existent din registru selectat: ',
            id: 1,
        },
        {
            name: 'Număr nou/la rând',
            id: 2,
        },
    ];

    registreOptions: { name: string; id: number }[] = [
        {
            name: 'Număr din oficiu/nou',
            id: 1,
        },
        {
            name: 'Număr anterior, intern zi curentă',
            id: 2,
        },
    ];

    proceduriDocumentOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Preluare număr pentru pregătire documentație',
            id: 1,
        },
        {
            name: 'Transmitere către alte Servicii/Compartimente',
            id: 2,
        },
    ];

    form: FormGroup = new FormGroup({
        id_categorie: new FormControl(3, []), // Hard coded for doc intern
        source: new FormControl(0, []), // Hard coded, needed?

        new_number: new FormControl(-1, []),
        id_serie: new FormControl(-1, []),
        registratura_number_type: new FormControl(1, [Validators.required, notDefaultValidator('-1')]),
        registratura_number: new FormControl('', []),
        exit_document_format: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        id_tip_document: new FormControl(null, [Validators.required]),
        name_tip_document: new FormControl('', [Validators.required]),
        observatii: new FormControl('', [Validators.required]),
        keywords: new FormControl('', [Validators.required]),
        no_pages: new FormControl('', [Validators.required]),

        // needed ?
        // id_print: new FormControl(0, []),
        // data_rezervata: new FormControl('', []),
    });

    formFiles: FormGroup = new FormGroup({
        files: this.fb.array([], []),
    })

    formDestinatie: FormGroup = new FormGroup({
        // id: new FormControl('', []), // Added in submitForm!
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        // dosar_original: new FormControl('', []) // Added in addDestinatieToTableData!
    });

    private destroy$ = new Subject<void>();

    registreActiveSwitch: Generic[] = [];

    tipDocumente: Generic[] = [];
    tipDocumenteControl = new FormControl('', [Validators.required]);
    isTipDocumenteLoading = false;
    showTipDocumenteMessage = true;
    tipDocumenteLoadComplete = false;

    directiiDestinatie: Generic[] = [];
    filteredDirectiiDestinatie: Generic[] = [];
    directiiDestinatieControl = new FormControl();

    compartimenteDestinatie: GenericCompartimentSearch[] = [];
    compartimenteDestinatieControl = new FormControl();
    isCompartimenteDestinatieLoading = false;
    showCompartimenteDestinatieMessage = true;
    compartimenteDestinatieLoadComplete = false;

    operatoriDestinatie: Generic[] = [];
    filteredOperatoriDestinatie: Generic[] = [];
    operatoriDestinatieControl = new FormControl();

    selectedSerieDocument: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData?: DocumentData,
            serieId?: number | -1,
            reg_number?: string,
            idDocumentActivity?: number
        },
        private dialogRef: MatDialogRef<DocumentInternComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        private toastService: ToastService,
    ) {
        // const foundRegistruOficial = this.data.generalData.find(item => item.name === 'registru_oficial')
        // this.registruOficialGeneralValue = foundRegistruOficial ? Number(foundRegistruOficial.value) : null;

        // If docData exists, it means the component is run from view doc!
        this.docData = data.docData ? data.docData : null;
    }

    ngOnInit() {
        this.loadActiveSwitch();
        this.loadDirectiiActiveDestinatie(0);

        this.isLoading = true

        if (this.data.serieId) {
            this.form.controls['id_serie'].patchValue(this.data.serieId);
            // this.onRegisteActiveSelected(this.data.serieId);
        }

        if (this.docData) {
            this.newNumberOptions[1].name = `Emitere cu număr existent din registru selectat: ${this.data.reg_number}`;
            this.form.controls['new_number'].setValidators([Validators.required, notDefaultValidator('-1')]);
            this.form.controls['new_number'].patchValue(1);
            this.form.controls['id_serie'].patchValue(this.data.serieId);

            this.showRegistreFields = false;

            // Update destinatie tableData with docData
            // this.docData.destinatie.forEach(item => {
            //     this.tableData.push({
            //         id: null,
            //         directie_id: item.destination_directie_id,
            //         directie_name: item.destination_directie_name,
            //         compartiment_id: item.destination_compartiment_id,
            //         compartiment_name: item.destination_compartiment_name,
            //         user_id: item.destination_user_id,
            //         user_name: item.destination_user_name,
            //         dosar_original: item.dosar_original === 1 ? true : false,
            //     })
            // })
        } else {
            this.form.controls['id_serie'].setValidators([Validators.required, notDefaultValidator('-1')]);
        }

        this.tipDocumenteControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchTipDocumente(value);
                this.showTipDocumenteMessage = true;
                this.tipDocumenteLoadComplete = false;
            }
        });

        this.compartimenteDestinatieControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteDestinatie(compartiment, 0);
                this.showCompartimenteDestinatieMessage = true;
                this.compartimenteDestinatieLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.directiiDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiDestinatie = this.directiiDestinatie;
                    return of(this.directiiDestinatie);
                }
                return this.filterDirectiiDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriDestinatie = this.operatoriDestinatie;
                    return of(this.operatoriDestinatie);
                }
                return this.filterOperatoriDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    fetchTipDocumente(search: string) {
        if (search && search.length >= 2) {
            this.isTipDocumenteLoading = true;
            this.commonService.searchTipDocumente(search).subscribe({
                next: (response: Generic[]) => {
                    this.tipDocumente = response;
                    this.isTipDocumenteLoading = false;
                    this.tipDocumenteLoadComplete = true;
                    this.showTipDocumenteMessage = this.tipDocumente.length === 0;
                },
                error: (err: any) => {
                    this.isTipDocumenteLoading = false;
                    this.showTipDocumenteMessage = true;
                    this.tipDocumenteLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.tipDocumente = [];
            this.showTipDocumenteMessage = true;
            this.tipDocumenteLoadComplete = false;
        }
    }

    onTipDocumenteSelected(selectedDocument: Generic) {
        if (selectedDocument) {
            this.form.controls['id_tip_document'].patchValue(selectedDocument.id);
            this.form.controls['name_tip_document'].patchValue(selectedDocument.name);
        }
    }

    displayTipDocumente(selectedDocument: Generic): string {
        return selectedDocument && selectedDocument.name ? selectedDocument.name : '';
    }

    onTipDocumenteBlur() {
        const currentValue = this.tipDocumenteControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tipDocumenteControl.patchValue('');
            this.form.controls['id_tip_document'].patchValue('');
            this.form.controls['name_tip_document'].patchValue('');
        }
    }

    loadActiveSwitch() {
        this.isLoading = true;
        this.commonService
            .getActiveSwitch()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.isLoading = false;
                    this.registreActiveSwitch = results;

                    // this formula is needed for only where we have ID Document or ID Document Activity BINDED
                    if (this.data.serieId && this.data.serieId !== -1) {
                        const foundSerie = this.registreActiveSwitch.find((obj: Generic) =>
                            Number(obj.id) === this.data.serieId
                        );
                        this.selectedSerieDocument = foundSerie?.name || null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    } else {
                        this.selectedSerieDocument = this.docData?.serie?.name ? this.docData.serie.name : null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    }

                },
                error: (error) => {
                    console.error('Error loading directii', error);
                },
            });
    }

    loadDirectiiActiveDestinatie(blocked: number) {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive(blocked)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiDestinatie = results;

                    this.filteredDirectiiDestinatie = [...this.directiiDestinatie];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiDestinatie = [];
                },
            });
    }

    onDirectiiDestinatieChange(selectedCompartiment: Generic): void {
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteDestinatieControl.patchValue('');
        this.formDestinatie.controls['compartiment_id'].patchValue('');
        this.formDestinatie.controls['compartiment_name'].patchValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayDirectiiDestinatie(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiDestinatieBlur() {
        const currentValue = this.directiiDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiDestinatieControl.patchValue('');
            this.formDestinatie.controls['directie_id'].patchValue('');
            this.formDestinatie.controls['directie_name'].patchValue('');

            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteDestinatie(compartiment: string, blocked: number) {
        // const directieDestinatieValue = this.formDestinatie.get('directie_id')?.value;
        // const directie = directieDestinatieValue && directieDestinatieValue !== -1 ? directieDestinatieValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteDestinatieLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment, blocked).subscribe({
                next: (response: any) => {
                    this.compartimenteDestinatie = response;
                    this.isCompartimenteDestinatieLoading = false;
                    this.compartimenteDestinatieLoadComplete = true;
                    this.showCompartimenteDestinatieMessage = this.compartimenteDestinatie.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteDestinatieLoading = false;
                    this.showCompartimenteDestinatieMessage = true;
                    this.compartimenteDestinatieLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteDestinatie = [];
            this.showCompartimenteDestinatieMessage = true;
            this.compartimenteDestinatieLoadComplete = false;
        }
    }

    onCompartimenteDestinatieSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formDestinatie.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiDestinatieControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriDestinatie();
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayCompartimenteDestinatie(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteDestinatieBlur() {
        const currentValue = this.compartimenteDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriDestinatie() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formDestinatie.controls['directie_id'].value,
            compartiment_id: this.formDestinatie.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriDestinatie = [...data];
                    this.filteredOperatoriDestinatie = [...this.operatoriDestinatie];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriDestinatie = [];
                },
            });
    }

    // onOperatoriDestinatieClosed() {
    //     const selectedValue = this.operatoriDestinatieControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriDestinatie.some(operator =>
    //             operator.id === this.formDestinatie.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriDestinatieControl.setValue(null);
    //             this.filteredOperatoriDestinatie = this.operatoriDestinatie;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriDestinatieChange(operatorId: number): void {
        const selectedOperator = this.operatoriDestinatie.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formDestinatie.controls['user_id'].patchValue(selectedOperator.id);
            this.formDestinatie.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriDestinatie(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriDestinatieBlur() {
    //     const currentValue = this.operatoriDestinatieControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriDestinatieControl.patchValue('');
    //         this.formDestinatie.controls['user_id'].patchValue('');
    //         this.formDestinatie.controls['user_name'].patchValue('');
    //     }
    // }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiDestinatie.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriDestinatie.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END


    onRegisteActiveSelected(registruActiveId: number) {
        // const registratura_number_type = this.form.get('registratura_number_type') as FormControl;
        // const registratura_number = this.form.get('registratura_number') as FormControl;
        // const exit_document_format = this.form.get('exit_document_format') as FormControl;

        // const files = this.formFiles.get('files') as FormArray;

        // if (registruActiveId !== this.registruOficialGeneralValue) {
        //     registratura_number_type.setValidators([Validators.required, notDefaultValidator('-1')]);
        //     registratura_number_type.markAsUntouched();
        //     this.showRegistreFields = true;

        //     exit_document_format.setValidators([Validators.required, notDefaultValidator('-1')]);
        //     exit_document_format.markAsUntouched();
        //     this.showProceduraField = true;
        // } else {
        //     registratura_number_type.patchValue(1); // Default number_type
        //     registratura_number_type.clearValidators();
        //     registratura_number_type.setErrors(null);
        //     registratura_number_type.markAsUntouched();
        //     this.showRegistreFields = false;

        //     exit_document_format.patchValue(-1);
        //     exit_document_format.clearValidators();
        //     exit_document_format.setErrors(null);
        //     exit_document_format.markAsUntouched();
        //     this.showProceduraField = false;
        // }

        // if (this.showRegistreFields === false) {
        //     registratura_number.patchValue('');
        //     registratura_number.clearValidators();
        //     registratura_number.setErrors(null);
        //     registratura_number.markAsUntouched();
        // }
        // if (this.showProceduraField === false) {
        //     files.clear();
        //     files.clearValidators();
        //     files.setErrors(null);
        //     files.markAsUntouched();
        //     this.showFormFiles = false;

        //     this.tableData.length = 0;
        //     this.showFormDestinatie = false;
        // }

        // this.form.updateValueAndValidity();
    }

    onRegistraturaTypeSelected(registraturaType: number) {
        const registratura_number = this.form.get('registratura_number') as FormControl;

        if (registraturaType === 2) {
            registratura_number.setValidators([Validators.required]);
            registratura_number.markAsUntouched();
        } else {
            registratura_number.patchValue('');
            registratura_number.clearValidators();
            registratura_number.setErrors(null);
            registratura_number.markAsUntouched();
        }

        this.form.updateValueAndValidity();
    }

    onProceduraIesireSelected(proceduraIesire: number) {
        const files = this.formFiles.get('files') as FormArray;

        if (proceduraIesire === 2) {
            files.setValidators([Validators.required]);
            files.markAsUntouched();
            this.showFormFiles = true;

            this.showFormDestinatie = true;
        } else {
            files.clear();
            files.clearValidators();
            files.setErrors(null);
            files.markAsUntouched();
            this.showFormFiles = false;

            this.tableData.length = 0;
            this.showFormDestinatie = false;
        }

        this.formFiles.updateValueAndValidity();
    }

    getIdentifier(directie_id: number, compartiment_id: number, user_id: number): string {
        const directieIdS = directie_id ? directie_id.toString() : '0';
        const compartimentIdS = compartiment_id ? compartiment_id.toString() : '0';
        const userIdS = user_id ? user_id.toString() : '0';
        const identifier = directieIdS + compartimentIdS + userIdS;
        return identifier;
    }

    addDestinatieToTableData() {
        const { directie_id, directie_name, compartiment_id, compartiment_name, user_id, user_name } = this.formDestinatie.value;
        if (!directie_id) { return };

        const newRowIndentifier = this.getIdentifier(directie_id, compartiment_id, user_id);
        const isRowAdded = this.tableData.some(row => this.getIdentifier(row.directie_id, row.compartiment_id, row.user_id) === newRowIndentifier);
        if (isRowAdded) { return };

        const newRow: DestinatieTableDataRow = {
            id: null,
            directie_id,
            directie_name,
            compartiment_id,
            compartiment_name,
            user_id,
            user_name,
            dosar_original: true,
        }

        this.tableData.push(newRow);
        this.formDestinatie.patchValue({
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
        });
        this.resetFormDestinatieFields();
    }
    resetFormDestinatieFields() {
        this.filteredDirectiiDestinatie = this.directiiDestinatie;
        this.directiiDestinatieControl.setValue('');

        this.compartimenteDestinatie = [];
        this.compartimenteDestinatieControl.setValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.setValue('');

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();
    }

    deleteTableDataRow(index: number) {
        this.tableData.splice(index, 1);
    }
    checkDocOriginal(index: number) {
        this.tableData[index].dosar_original = !this.tableData[index].dosar_original;
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.formFiles.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.toastService.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.dashboardService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.formFiles.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading = false;

                            this.toastService.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        // Handle error cases here
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    downloadFile(uploadedFile: FileUpload) {
        const fullPath = this.dashboardService.tempFileDownloadUrl;
        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    removeFile(index: number) {
        const files = this.formFiles.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.toastService.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    findInvalidControls(formGroup: FormGroup) {
        const invalid = [];
        const controls = formGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    areFormsValid() {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();

        this.tipDocumenteControl.markAsTouched();

        if (
            this.form.invalid ||
            (this.showFormFiles && this.formFiles.invalid) ||
            (this.showFormDestinatie && this.tableData.length === 0)
        ) {
            console.log('Invalid in this.form:', this.findInvalidControls(this.form));
            return false;
        } else {
            return true;
        }
    }

    submitForm() {
        if (this.areFormsValid()) {
            Swal.fire({
                title: helper.dialogConfig.commonTitles.areYouSure,
                text: 'O să înregistrați documentul completat în registratură!',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: helper.dialogConfig.buttonLabels.close,
                confirmButtonColor: helper.dialogConfig.colorButtons.standard,
                confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
                showLoaderOnConfirm: true,
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.storeDoc();
                }
            });
        } else {
            Swal.fire({
                title: helper.dialogConfig.headers.error,
                text: 'Verificați din nou câmpurile obligatorii şi validitatea informațiilor.',
                icon: 'error',
                confirmButtonText: helper.dialogConfig.buttonLabels.close
            });
        };
    }

    storeDoc() {
        this.isLoading = true;

        const document = {
            ...this.form.value,
            destinatie: this.tableData.map((item, index) => {
                item.id = index + 1
                return item;
            }),
            // docData
            id_document: this.docData ? this.docData.id_document : null,
            id_document_activity: this.data.idDocumentActivity,
        };

        const payload = {
            document,
            files: this.formFiles.value.files,
        }

        this.dashboardService
            .storeDocumentIntern(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: `${res.data.reg_number} - ${res.data.reg_date}`,
                        text: `Documentul înregistrat cu succes cu numărul ${res.data.reg_number} - ${res.data.reg_date}`,
                        icon: 'success',
                        showCancelButton: true,
                        cancelButtonColor: helper.dialogConfig.colorButtons.info,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        confirmButtonColor: helper.dialogConfig.colorButtons.secondary,
                        confirmButtonText: 'Deschide Document',
                        showLoaderOnConfirm: true,
                        // reverseButtons: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            // Redirect to document url when Confirmed(Deschide Document) is clicked
                            const url = `#/documente?id=${res.data.id_document}`;
                            window.open(url, '_blank');

                            // Return false to prevent the modal from closing
                            return false;
                        }
                    }).then((result) => {
                        // This will only trigger when Cancel is clicked
                        if (result.isDismissed) {
                            this.dialogRef.close({ success: true, resData: res.data });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
